<template>
  <!-- form -->
  <div
    id="_login_form_frame"
    :class="`rounded-borders q-pa-md role-border-${selectedRole}`"
  >
    <ul class="login-role-select">
      <li
        class="
          login-role-select-item
          q-px-md q-py-xs
          tl-transition-1
          cursor-pointer
        "
        v-for="role in roles"
        :key="role.value"
        :class="{
          [`role-${role.value}`]: true,
          'role-selected': selectedRole === role.value,
          'q-px-lg': selectedRole === role.value,
        }"
        @click="changeRole(role.value)"
      >
        {{ role.label }}
      </li>
    </ul>

    <div class="row justify-end q-mb-lg">
      <q-item class="row items-center" dense clickable @click="toggleLoginType">
        <q-icon name="fas fa-exchange-alt" size="10px" class="q-mr-sm" />
        <span class="text-caption">
          切换{{ loginType === "password" ? "验证码登录" : "密码登录" }}
        </span>
      </q-item>
    </div>

    <!-- 账号密码登录 -->
    <q-tab-panels animated v-model="loginType" class="bg-transparent">
      <q-tab-panel name="password">
        <section class="login-form-item">
          <span class="lfi-label">账号</span>
          <q-input
            :clearable="false"
            dense
            class="lfi-input"
            label="用户名/手机号"
            filled
            v-model="usernameInput"
            counter
            maxlength="11"
          />
        </section>

        <section class="login-form-item" style="margin-bottom: 0">
          <span class="lfi-label">密码</span>
          <q-input
            dense
            class="lfi-input"
            label="密码"
            :type="showPassword ? 'text' : 'password'"
            filled
            :clearable="false"
            v-model="passwordInput"
            @focus="showTogglePassword = true"
            @blur="showTogglePassword = false"
            @keyup.enter="readyToLogin ? loginByPassword() : ''"
            counter
            maxlength="16"
          >
            <template v-slot:append>
              <transition
                appear
                enter-active-class="animated animate__fadeIn"
                leave-active-class="animated animate__fadeOut"
              >
                <q-icon
                  v-show="showTogglePassword && passwordInput.length"
                  class="toggle-password-show"
                  @click.prevent.stop="showPassword = !showPassword"
                  :name="`fas fa-eye${showPassword ? '' : '-slash'}`"
                  size="12px"
                />
              </transition>
            </template>
          </q-input>
        </section>
        <div class="row justify-end text-caption text-grey">
          <!-- <a href="#">忘记密码</a> -->
        </div>
      </q-tab-panel>
      <q-tab-panel name="sms">
        <section class="row no-wrap items-start q-mb-md">
          <q-input
            class="col-7"
            type="text"
            v-model="phoneNumberInput"
            filled
            dense
            @input="checkPhoneNumberInput"
            :error="!!phoneNumberInputErrorMsg"
            :error-message="phoneNumberInputErrorMsg"
            no-error-icon
            maxlength="11"
            counter
            label="请输入手机号"
          />
          <q-btn
            style="height: 40px"
            class="col-5 q-ml-xs col-shrink"
            outline
            color="primary"
            @click="sendVericationCode"
            :disable="
              !phoneNumberInput ||
                verificationCodeWait > 0 ||
                !!phoneNumberInputErrorMsg
            "
          >
            <span v-if="verificationCodeWait === 0">获取验证码</span>
            <span v-else>{{ verificationCodeWait }} 秒后重试</span>
          </q-btn>
        </section>
        <section v-if="phoneNumberSentCode && bizId">
          <div>
            <span>验证码已发送到</span>
            <span class="text-primary text-bold">
              {{ phoneNumberSentCode }}
            </span>
            <span>请注意查收，该验证码3分钟内有效</span>
          </div>
          <CheckCodeInput
            v-model="verificationCode"
            type="text"
            highLightColor="var(--q-color-primary)"
            :margin="2"
          />
        </section>
      </q-tab-panel>
    </q-tab-panels>

    <section class="row justify-center q-mt-md">
      <q-btn
        flat
        class="bg-primary text-white text-bold"
        :disable="!readyToLogin"
        @click="
          loginType === 'password'
            ? loginByPassword()
            : loginType === 'sms'
            ? loginBySms()
            : ''
        "
      >
        登录
      </q-btn>
    </section>
  </div>
</template>

<script>
import AuthMixin from "./auth.mixin";
import AuthFormatMixin from "./format.mixin";
import { sendVerificationCode } from "../../api/endpoints/sms/sendVerificationCode";
import { loginWithPassword } from "../../api/endpoints/auth/loginWithPassword";
import { loginWithSms } from "../../api/endpoints/auth/loginWithSms";
const roles = [
  {
    label: "访员",
    value: "member",
  },
  {
    label: "组长",
    value: "leader",
  },
  {
    label: "管理员",
    value: "admin",
  },
];
export default {
  mixins: [AuthFormatMixin, AuthMixin],
  components: {
    CheckCodeInput: () => import("@/components/CheckcodeInput"),
  },

  mounted() {
    const { role } = this.$route.query;
    if (roles.every(({ value }) => value !== role)) {
      this.changeRole(roles[0].value);
    }
    this.resolveUserStatus();
  },

  data() {
    return {
      loading: false,

      showPassword: false, // 显示密码
      showTogglePassword: false, // 显示切换密码的小眼睛
      usernameInput: "", // 输入框中的用户名
      passwordInput: "", // 输入框中的密码
      phoneNumberInput: "", // 输入框中的手机号
      phoneNumberSentCode: "", // 已发送验证码的手机号
      phoneNumberInputErrorMsg: "", // 手机号输入的错误信息
      verificationCode: "", // 输入框中输入的验证码
      bizId: "", // 短信服务的短信标识

      verificationCodeWait: 0,
      codeWaitInterval: null,

      roles,
      // selectedRole: "member",

      loginType: "password", // "password" | "sms"
    };
  },

  computed: {
    readyToLogin() {
      const { loginType } = this;
      if (loginType === "password") {
        return this.usernameInput.length && this.passwordInput.length;
      } else if (loginType === "sms") {
        return (
          this.phoneNumberSentCode.length && this.verificationCode.length === 6
        );
      } else {
        return false;
      }
    },

    selectedRole() {
      return this.$route.query.role;
    },
  },

  methods: {
    changeRole(role) {
      if (this.$route.query.role === role) return;
      this.$router.replace({
        query: {
          ...this.$route.query,
          role,
        },
      });
    },

    /**
     * 登录方式切换
     */
    toggleLoginType() {
      if (this.loginType === "password") {
        this.loginType = "sms";
        if (!this.phoneNumberInput && this.usernameInput) {
          if (
            this.usernameInput.length === 11 &&
            this.checkPhoneNumber(this.usernameInput)
          ) {
            this.phoneNumberInput = this.usernameInput;
          }
        }
      } else this.loginType = "password";
    },

    /**
     * 请求发送验证码到手机
     */
    async sendVericationCode() {
      this.verificationCodeWait = 60;
      this.codeWaitInterval = setInterval(() => {
        this.verificationCodeWait--;
        if (this.verificationCodeWait === 0) {
          clearInterval(this.codeWaitInterval);
        }
      }, 1000);
      const { phoneNumberInput } = this;
      this.phoneNumberSentCode = phoneNumberInput;
      this.bizId = "";
      try {
        const response = await sendVerificationCode({
          phoneNumber: this.phoneNumberSentCode,
          action: "login",
        });
        if (response.BizId) {
          this.bizId = response.BizId;
        } else if (response.error) {
          this.$q.notify({
            type: "danger",
            message: response.message,
          });
        } else {
          throw Error(response);
        }
      } catch (err) {
        console.log(err);
        this.$q.notify({
          type: "danger",
          message: "发送验证码时出现未知错误",
        });
      } finally {
        if (!this.bizId) {
          clearInterval(this.codeWaitInterval);
          this.codeWaitInterval = null;
          this.verificationCodeWait = 0;
        }
      }
    },

    /**
     * 检查输入的手机号
     */
    async checkPhoneNumberInput(value) {
      const legal = this.checkPhoneNumber(value);
      this.phoneNumberInputErrorMsg = legal ? "" : "手机号格式有误";
    },

    /**
     * 账号密码登录
     */
    async loginByPassword() {
      this.loading = true;
      const { usernameInput, passwordInput, selectedRole } = this;
      try {
        const response = await loginWithPassword(
          usernameInput,
          passwordInput,
          selectedRole
        );
        if (response && response.status) {
          this.$q.notify({
            type: "danger",
            message: response.detail || response.message,
          });
        } else {
          // 登录成功
          this.$q.notify({ type: "success", message: "登录成功" });
          this.resolveUserStatus();
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
      }
    },

    /**
     * 短信验证码 登录
     */
    async loginBySms() {
      const {
        bizId,
        verificationCode,
        phoneNumberSentCode,
        selectedRole,
      } = this;
      this.loading = true;
      try {
        const response = await loginWithSms(
          {
            phoneNumber: phoneNumberSentCode,
            code: verificationCode,
            bizId,
          },
          selectedRole
        );

        if (response.status || response.error) {
          this.$q.notify({
            type: "danger",
            message: response.detail || response.message,
          });
        } else {
          this.$q.notify({ type: "success", message: "登录成功" });
          this.resolveUserStatus();
        }
      } catch (err) {
        console.log(err);
        this.$q.notify({
          type: "danger",
          message: "未知错误",
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/quasar";

#_login_form_frame {
  margin-top: 100px;
  position: relative;

  .q-field--error .q-field__bottom {
    padding: 7px 0 0 1px !important;
  }
  &.role-border-admin {
    border: 2px solid $primary;
  }
  &.role-border-leader {
    border: 2px solid $tailong-blue;
  }
  &.role-border-member {
    border: 2px solid $secondary;
  }
}

.login-role-select {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: calc(100% + 2px);
  list-style: none;
  white-space: nowrap;
}

.login-role-select-item {
  display: inline-block;
  border-top-left-radius: $generic-border-radius;
  border-top-right-radius: $generic-border-radius;
  color: #fff;
  font-weight: bold;
  margin: 0 2px;

  background-color: $grey-4;

  &.role-selected {
    &.role-admin {
      background-color: $primary;
    }
    &.role-leader {
      background-color: $tailong-blue;
    }
    &.role-member {
      background-color: $secondary;
    }
  }
}

.login-form-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 10px;

  .lfi-label {
    width: 20%;
    font-weight: bold;
  }
  .lfi-input {
    width: 80%;
  }
}
</style>
